export const scrolltoref = {
	mounted () {
		this.$bus.$on('scrollToRef', this.scrollToRef)
	},
	beforeDestroy () {
		this.$bus.$off('scrollToRef', this.scrollToRef)
	},
	methods : {
		scrollToRef (refId, args = {
			behavior : 'smooth',
			block    : 'start',
			inline   : 'nearest',
			offset   : 0,
		}) {
			const el = this.$get(`$refs.${refId}`) || document.querySelector(refId)

			if (el) {
				if (args.offset && el.getBoundingClientRect) {
					const top = el.getBoundingClientRect().top + window.pageYOffset + args.offset
					window.scrollTo({ top, behavior: args.behavior || 'smooth' })
					return true
				}

				if (el.scrollIntoView) {
					delete args.offset
					el.scrollIntoView(args)
					return true
				}
			}

			return false
		},
	},
}
